var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsuarios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #191b35;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #6dbb7b;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M657.35,1076.71c-18.43-8.15-24.51-22.71-23.7-42.16,1.28-30.71-1.87-61.59,3.84-92.13,9.3-49.74,33-91.32,70.45-125.36,78.08,94.48,216.06,94.2,292.33.15a206.27,206.27,0,0,1,56.63,72.63c13.31,28.15,20.34,57.83,20.24,89.09-.07,18.88-.89,37.81.23,56.62,1.24,20.61-6.5,34.32-26.08,41.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.66,1076.71C9,1069.34,1.56,1056.3,2.59,1037c1.56-29.07-2-58.33,2.35-87.31,8-52.68,33.45-96,71.67-132.59,77.64,92.71,213.2,95.94,292.39.13,27.89,23,48.18,51.38,61.72,84.76C441,927.45,445.65,954,446,981.33c.22,17.55-.7,35.15.24,52.66,1.1,20.47-5.85,35.21-25.63,42.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M393.58,246.14c69.34,88.76,209.3,99.64,292.72,0,47.55,41.43,74.06,93.09,76.3,156.37.85,24.14.26,48.34.17,72.52-.08,19-11.92,31.72-30.8,33.24-3.63.3-7.28.43-10.92.43q-182.46,0-364.92.07c-10.85,0-21.25-.77-29.43-9-5.25-5.31-9.4-11.6-9.33-19.14.32-32.41-2.6-64.94,1.59-97.23C326.12,328.14,353.05,283.44,393.58,246.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M665.52,126.5c-.3,71.31-56.65,125.64-129.85,125.21-71.67-.42-127.26-55.56-127.08-126C408.77,57,465.78,3,538,3.29,609.34,3.54,665.81,58.1,665.52,126.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.07,571.55c68.31.2,126,56.88,125.69,123.4C348.4,763,290.15,820.56,222.07,820.06c-67.9-.51-125.17-57.91-125.33-125.62C96.58,628.07,154.89,571.35,223.07,571.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M853.83,822.46c-66.1-.31-123-57.49-122.7-123.28.32-67.37,57.57-125.41,123.49-125.21,68.5.22,125.6,57.9,125.22,126.5C979.48,767.05,921.9,822.79,853.83,822.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M537.13,714.2l-97.3,91.23c-11.55-18.21-24.62-33.79-43.18-45.94,10.55-10.32,20.31-19.71,29.9-29.27,24.18-24.07,48.17-48.33,72.51-72.24,4.85-4.76,7.07-9.53,6.95-16.43-.41-22.81-.16-45.64-.16-69.26h62.4c0,23.08.27,45.84-.16,68.58-.14,7.21,2,12.27,7.08,17.42,33.72,34.18,67.1,68.69,101.63,104.17-15.09,13.42-29.29,27-42.49,43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuarios);
export default __webpack_public_path__ + "static/media/usuarios.0c32bafdd358b96b8c37763d039b399f.svg";
export { ForwardRef as ReactComponent };